/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventMessageReadContentDto { 
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * id сообщения
     */
    messageId: string;
    /**
     * Пользователь, который прочитал сообщение
     */
    userId: string;
    /**
     * время прочтения сообщения
     */
    readAt: string;
}

